import styled from "styled-components";
import {Dropdown} from "react-bootstrap";

export const ContextMenuContainer = styled.div`
    display: flex;
  //position: relative;
`
export const DropdownToggle = styled(Dropdown.Toggle)`
  margin: 0;
  padding: 0;
  opacity: 0;
  height: 0;
`
